module.exports = __webpack_public_path__ + "static/media/SplunkCluster.123ba89d.png";